import { useState, useCallback, DependencyList } from 'react';

export interface LazyFetchState {
  loading: boolean;
  error: Error | null;
  response: any;
}

type Data = object;

type LazyFetch = [(data: Data) => any, LazyFetchState];

const useLazyFetch = (url: string, deps: DependencyList = []): LazyFetch => {
  const [state, set] = useState<LazyFetchState>({
    loading: false,
    error: null,
    response: null,
  });

  const fetchData = useCallback(async (data: Data) => {
    set({ ...state, loading: true });

    try {
      const response = await fetch(url, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
      });
      const json = await response.json();

      set({ ...state, response: json, loading: false });
    } catch (error) {
      set({ ...state, error, loading: false });
    }
  }, deps);

  return [fetchData, state];
};

export default useLazyFetch;
